<script setup lang="ts">
import RedistributionQueueDrawer from "../components/RedistributionQueueDrawer.vue";
import OpenPurchaseOrdersResultsPanel from "../features/home/OpenPurchaseOrdersResultsPanel.vue";
</script>

<template>
  <div class="home-layout page-main-container">
    <div class="home-results-shell">
      <OpenPurchaseOrdersResultsPanel />
    </div>
    <RedistributionQueueDrawer />
  </div>
</template>
